var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4F4D\\u56FE\\u5907\\u4EFD-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#EBEFF0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ethereum-eth-logo",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.833333, 83.333333)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#444444",
    points: "103.934358 0.333167989 101.66212 8.04976852 101.66212 231.953538 103.934358 234.220817 207.864997 172.785218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#9E9E9E",
    points: "103.934358 0.333167989 0 172.785218 103.934358 234.220817"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#3C3C3B",
    points: "103.934358 253.897156 102.65377 255.458829 102.65377 335.217841 103.934358 338.955853 207.929481 192.495453"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#9E9E9E",
    points: "103.934358 338.955853 103.934358 253.897156 0 192.495453"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#1A1A1A",
    points: "103.934358 234.220817 207.864997 172.785218 103.934358 125.544395"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#4A4A4A",
    points: "0 172.785218 103.934358 234.220817 103.934358 125.544395"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.3a612f071f32ca46b19ee5b410f15546.svg";
export { ForwardRef as ReactComponent };